export const KEY_POST_CONTENTS_LIKES = 'post.contents-likes.call';
export const KEY_GET_CONTENTS_LIKES = 'get.contents-likes.call';
export const KEY_DELETE_CONTENTS_LIKES = 'delete.contents-likes.call';
export const KEY_GET_ADMIN_CONTENTS_LIKES_BY_CONTENT_TYPE =
  'get.admin-contents-likes-by-content-type.call';
export const KEY_GET_ADMIN_CONTENTS_LIKES_USERS = 'get.admin-contents-likes-users.call';
export const KEY_PUT_CONTENTS_FAVORITES = 'put.contents-favorites.call';
export const KEY_DELETE_CONTENTS_FAVORITES = 'delete.contents-favorites.call';
